// CANONICAL COPY (GH #7115). src/constants/obligations/obl-equipment-disposal.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-equipment-disposal',
  title: 'Verify secure equipment disposal procedures',
  description:
    'Confirm that equipment containing storage media is verified — prior to disposal, re-use or transfer — to ensure sensitive data has been removed or securely overwritten using approved sanitisation methods. Retain certificates of destruction or sanitisation evidence for audit.',
  category: 'assets',
  scfIds: ['SCF-PHY-014'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Equipment disposal / sanitisation procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
